// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jd__company-about[data-v-36428e48]{margin-top:.75rem;white-space:pre-wrap;word-wrap:break-word}@media (min-width:960px){[data-v-36428e48] p,[data-v-36428e48] span{font-size:1.0625rem}.jd-section.jd-section--company[data-v-36428e48]{padding-top:1.75rem}.jd-section.jd-section--company h2[data-v-36428e48]{margin-bottom:1rem}}", ""]);
// Exports
module.exports = exports;
